import styled from "styled-components";
import { Spinner } from "styles/components";
import { Button } from "styles/elements";
import { Theme } from "theme";

export const ConfirmSpinner = styled(Spinner)`
  border-width: ${Theme.spinnerSmallBorderWidth};
  width: 8px;
  height: 8px;
  margin: auto;
`;

export const InitialButton = styled(Button)`
  width: 100px;
`;
